import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";


@Injectable({
    providedIn: 'root'
})

export class LogProvider {

    constructor(private http: HttpClient,
        private logger: NGXLogger) {
    }

    storeLog(data: any, link: string, message: string ='Router Event') {
        this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
          let dat = {
            ip: res.ip,
            zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            current_url: link,
            json: data
          }
          this.logger.error(message,dat);
        });
    }
}